<template>
  <div>
    <div class="slide-one"></div>
    <div class="content-center" style="padding: 40px 0 80px">
      <div class="warp">
        <div class="title">
          <div @click="turnTo('/aboutMe')">关于我们</div>
          <div @click="turnTo('/addWe')">加入我们</div>
          <div class="active">联系我们</div>
        </div>
        <div class="content">
          <div class="content-line">
            <img src="../assets/ic_cu_01.png" alt="" />
            <div>
              <p style="color: #757575">市场商务合作</p>
              <p class="hei-t">marketing@huolala.cn</p>
            </div>
          </div>
          <div class="content-line">
            <img src="../assets/ic_cu_05.png" alt="" />
            <div>
              <p style="color: #757575">企业用车商务合作</p>
              <p class="hei-t">qiye@huolala.cn</p>
            </div>
          </div>
          <div class="content-line">
            <img src="../assets/ic_cu_02.png" alt="" />
            <div>
              <p style="color: #757575">客服热线</p>
              <p class="hei-t">1010-3636</p>
            </div>
          </div>
          <div class="content-line">
            <img src="../assets/ic_cu_06.png" alt="" />
            <div>
              <p style="color: #757575">吐槽邮箱(其他服务建议/意见)</p>
              <p class="hei-t">tu-cao@huolala.cn</p>
            </div>
          </div>
          <div class="content-line">
            <img src="../assets/ic_cu_05.png" alt="" />
            <div>
              <p style="color: #757575">廉正贪腐举报(内部员工)</p>
              <p class="hei-t">举报专线 0755-88607615（专人管理）</p>
              <p class="hei-t">举报邮箱 icac@huolala.cn</p>
            </div>
          </div>
          <div class="content-line">
            <img src="../assets/ic_cu_03.png" alt="" />
            <div>
              <p style="color: #757575">公司地址</p>
              <p class="hei-t">深圳市福田区梅华路105号多丽工业区科技楼802</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    turnTo (path) {
      this.$router.push({ path })
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-one {
  height: 520px;
  background: url(../assets/aboutMe.png) no-repeat center;
  background-size: cover;
  position: relative;
}
.content-center {
  width: 1080px;
  margin: 0 auto;
  padding: 10px 50px;
}
.warp {
  display: flex;
  .title {
    width: 100px;
    height: 344px;
    padding-top: 20px;
    border-right: 1px solid #eaeaea;
    font-size: 14px;
    font-weight: 400;
    color: #2f3439;
    line-height: 33px;
    > div {
      padding: 0 13px;
      cursor: pointer;
    }
    .active {
      color: #f16622;
      position: relative;
    }
    .active::before {
      content: "";
      position: absolute;
      top: 10px;
      left: 0;
      width: 2px;
      height: 13px;
      background: #f16622;
    }
  }
  .content {
    flex: 1;
    padding: 0 100px;
    .content-line {
      display: flex;
      margin-bottom: 20px;
      img {
        width: 72px;
        height: 72px;
      }
      > div {
        flex: 1;
        margin-left: 33px;
      }
      .hei-t {
        font-size: 18px;
        color: #212121;
        line-height: 28px;
        margin-top: 10px;
      }
    }
  }
}
</style>